export default [
  {
    path: "correos",
    name: "mail-maintainer-list",
    component: () => import("@/modules/mail-maintainer/views/MailList.vue"),
    meta: {
      requiresAuth: true,
      roles: ["superadmin", 'mantenedor'],
    },
    /*children: [
      {
        path: ":id",
        name: "mail-maintainer-show",
        component: () => import("@/modules/mail-maintainer/views/MailShow.vue"),
      },
    ],*/
  },
];
